// src/Navbar.js
import React, { useState } from "react";
import { Link } from "react-router-dom"; // Updated for React Router
import logo from "../assets/logo.png";

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDrawer = () => {
        setIsOpen(!isOpen);
    };

    return (
        <header className="bg-white text-secondary">
            <div className="container mx-auto px-4 py-4 flex justify-between items-center relative">

                {/* Logo and Company Name */}
                <div className="flex items-center space-x-3">
                    <img
                        src={logo}
                        alt="Logo"
                        className="h-8 md:h-10 object-contain border border-secondary rounded-md p-0.5"
                    />
                    <span className="text-xl sm:text-2xl md:text-4xl font-normal leading-none">
                        NAVAM BIZ SOLUTIONS
                    </span>
                </div>

                {/* Hamburger Menu for Mobile */}
                <div className="md:hidden">
                    <button onClick={toggleDrawer} className="focus:outline-none text-secondary">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
                        </svg>
                    </button>
                </div>

                {/* Desktop Menu Items */}
                <div className="hidden md:flex space-x-8">
                    <Link to="/home" className="hover:text-blue-300">Home</Link> {/* Updated Link */}
                    <Link to="/about" className="hover:text-blue-300">About</Link> {/* Updated Link */}
                    <Link to="/contact" className="hover:text-blue-300">Contact Us</Link> {/* Updated Link */}
                </div>
            </div>

            {/* Sliding Mobile Drawer Menu */}
            <div className={`fixed top-0 right-0 h-full w-64 bg-white shadow-md transform ${isOpen ? 'translate-x-0' : 'translate-x-full'} transition-transform duration-300 ease-in-out z-50 md:hidden`}>
                <nav className="flex flex-col space-y-4 px-4 py-4">
                    <button onClick={toggleDrawer} className="self-end mb-4 focus:outline-none">
                        <svg className="w-6 h-6 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                    <Link to="/home" className="hover:text-blue-300" onClick={toggleDrawer}>Home</Link> {/* Updated Link */}
                    <Link to="/about" className="hover:text-blue-300" onClick={toggleDrawer}>About</Link> {/* Updated Link */}
                    <Link to="/contact" className="hover:text-blue-300" onClick={toggleDrawer}>Contact Us</Link> {/* Updated Link */}
                </nav>
            </div>
        </header>
    );
}

export default Navbar;
